<template>
  <div>
    <base-card>
      <h3 class="tw-text-lg tw-leading-6 tw-font-normal tw-text-gray-900">Default Payment Method</h3>
      <CreditCard :user-id="userId" class="tw-mt-2 smt:tw-mt-3" />
      <div class="tw-flex tw-items-center tw-mt-2.5">
        <base-toggle :value="user.useGlobalCard" @click.native="$refs.globalCardConfirmationModal.show()" />
        <span class="tw-text-gray-600 tw-ml-1.5 tw-text-sm">Use this card for all savings plans</span>
      </div>
    </base-card>
    <base-card class="tw-mt-6" no-padding>
      <h3 class="tw-text-lg tw-leading-6 tw-font-normal tw-text-gray-900 tw-pt-2.5 tw-px-4 sm:tw-pt-4 sm:tw-px-6">Savings Plan Payment Methods</h3>
      <ul v-if="isLoading || isPlansLoading">
        <li
          v-for="i in planPaymentMethods.length || 3"
          :key="i"
          :class="['tw-flex tw-justify-between tw-items-center tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6', { 'tw-border-b': i < 3 }]"
        >
          <div>
            <div class="tw-flex tw-items-center tw-mt-1.5 tw-mb-1">
              <base-skeleton-loader class="tw-w-24 tw-h-3" />
            </div>
            <base-skeleton-loader class="tw-w-12 tw-h-2 tw-mt-2.5 tw-mb-0.5" />
          </div>
          <div>
            <div class="tw-flex tw-justify-between tw-items-center">
              <div class="tw-flex">
                <base-skeleton-loader class="tw-h-4 tw-w-5 tw-mt-0.5" />
                <div class="tw-ml-3 tw-text-sm">
                  <base-skeleton-loader class="tw-h-3 tw-mb-1.5 tw-mt-0.5 tw-w-10" />
                  <base-skeleton-loader class="tw-h-2 tw-my-1 tw-w-8 tw-mt-2.5" />
                </div>
              </div>
              <base-skeleton-loader class="tw-rounded-full tw-h-5 tw-w-5 tw-ml-8" />
            </div>
          </div>
        </li>
      </ul>
      <ul v-else-if="planPaymentMethods.length">
        <li
          v-for="(planPaymentMethod, planPaymentMethodIndex) in planPaymentMethods"
          :key="planPaymentMethod.userBusinessPlanId"
          :class="['tw-flex tw-justify-between tw-items-center tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6', { 'tw-border-b': planPaymentMethodIndex + 1 < planPaymentMethods.length }]"
        >
          <div>
            <div>
              {{ planPaymentMethod.planName }}
            </div>
            <div class="tw-text-gray-600 tw-text-sm tw-leading-none">{{ planPaymentMethod.businessName }}</div>
          </div>
          <div class="tw-flex tw-items-center">
            <div class="tw-flex">
              <credit-card-icon class="tw-text-gray-700 tw-h-4 tw-text-lg tw-mt-0.5" :name="planPaymentMethod.brand" />
              <div class="tw-ml-3 tw-text-sm" v-if="planPaymentMethod.last4">
                <div>**** {{ planPaymentMethod.last4 }}</div>
                <div class="tw-text-gray-500 tw-text-xs">Exp {{ expDate(planPaymentMethod.expirationMonth, planPaymentMethod.expirationYear) }}</div>
              </div>
              <div class="tw-ml-3 tw-text-gray-500" v-else>No Card</div>
            </div>
            <base-icon class="tw-ml-2.5" @click="$refs.editPlanPaymentMethodModal.show([planPaymentMethod])">
              <edit-icon class="tw-w-3.5 tw-h-3.5" />
            </base-icon>
          </div>
        </li>
      </ul>
      <div class="tw-flex tw-justify-center tw-py-5" v-else>No Payment Methods</div>
    </base-card>
    <global-card-confirmation-modal ref="globalCardConfirmationModal" :use-global-card.sync="user.useGlobalCard" :user-id="userId" />
    <edit-plan-payment-method-modal ref="editPlanPaymentMethodModal" :user-id="userId" @updated="loadPlanPaymentMethods()" />
  </div>
</template>

<script>
import CreditCard from "@/components/CreditCardv2/CreditCard";
import CreditCardIcon from "@/components/CreditCardIcon.vue";
import GlobalCardConfirmationModal from "@/views/user/components/GlobalCardConfirmationModal";
import EditPlanPaymentMethodModal from "@/views/user/components/EditPlanPaymentMethodModal";
import { padStart } from "lodash";
import { EditIcon } from "@/assets/svgs";

export default {
  components: {
    CreditCard,
    CreditCardIcon,
    GlobalCardConfirmationModal,
    EditPlanPaymentMethodModal,
    EditIcon,
  },
  props: {
    isLoading: Boolean,
    user: Object,
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPlansLoading: false,
      planPaymentMethods: [],
    };
  },
  created() {
    this.loadPlanPaymentMethods();
  },
  methods: {
    async loadPlanPaymentMethods() {
      this.isPlansLoading = true;
      await this.$axios
        .get(`/users/${this.userId}/paymentmethods`)
        .then((res) => {
          this.isPlansLoading = false;
          this.planPaymentMethods = res.data;
        })
        .catch((err) => {
          // todo: handle
          this.isPlansLoading = false;
          console.log(err);
          debugger;
        });
    },
    expDate(expMonth, expYear) {
      return `${padStart(expMonth, 2, "0")} / ${expYear.toString().slice(-2)}`;
    },
  },
};
</script>
